export const extractYouTubeVideoId = (uri: string): string | null => {
  try {
    const url = new URL(uri);

    if (url.hostname === 'youtu.be') {
      const videoId = url.pathname.slice(1);
      return videoId.length === 11 ? videoId : null;
    }

    if (!url.hostname.endsWith('youtube.com')) {
      return null;
    }

    if (url.pathname === '/watch') {
      const videoId = url.searchParams.get('v');
      return videoId?.length === 11 ? videoId : null;
    }

    const pathMatch = url.pathname.match(/^\/(?:embed|live|v)\/([^/]+)/);
    const videoId = pathMatch?.at(1) ?? null;
    return videoId?.length === 11 ? videoId : null;
  } catch {
    return null;
  }
};
